import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import add_45to_45cart_45global from "/vercel/path0/middleware/add-to-cart.global.ts";
import detect_45device_45global from "/vercel/path0/middleware/detectDevice.global.ts";
import giftcard_45redirect_45global from "/vercel/path0/middleware/giftcard-redirect.global.ts";
import remove_45end_45slash_45global from "/vercel/path0/middleware/remove-end-slash.global.ts";
import static_45filter_45global from "/vercel/path0/middleware/static-filter.global.ts";
export const globalMiddleware = [
  validate,
  add_45to_45cart_45global,
  detect_45device_45global,
  giftcard_45redirect_45global,
  remove_45end_45slash_45global,
  static_45filter_45global
]
export const namedMiddleware = {}